const AbstractModel = {"REMOVED_FLAG_DELETE":2,"REMOVED_FLAG_YES":1,"REMOVED_FLAG_NO":0,"ID":"id","ARCHIVED":"arch","CREATED_AT":"created_at","UPDATED_AT":"updated_at"}; export default AbstractModel;
